// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import useScrollRestoration from '../../../hooks/useScrollRestoration';
// import {
//   Box,
//   Card,
//   Typography,
//   IconButton,
//   Chip,
//   CircularProgress,
//   Paper,
// } from '@mui/material';

// import {
//   FavoriteBorder,
//   Favorite,
//   LocationOn,
//   East,
//   ChevronRight,
// } from '@mui/icons-material';

// import axios from 'axios';

// import buildingImage from './../../../Images/house.jpeg';
// import CustomSearchBar from './../Lease Module/CustomSearch';

// // =====================================================================
// // API CONSTANTS
// // =====================================================================
// const BASE_URL = 'https://landnest.net:81';
// const ACTIVITIES_API = `${BASE_URL}/activities/`;
// const USER_CART_API = `${BASE_URL}/user-cart/`;

// // Replace with your real logged-in user (context, redux, localStorage...)
// const getUserId = () => Number(localStorage.getItem('user_id'));

// // =====================================================================
// // THEME COLORS (matched to BHKDescription)
// // =====================================================================
// const COLORS = {
//   primary: '#8B4A2B',
//   primaryDark: '#6B3620',
//   primaryLight: '#FBEEE0',
//   textDark: '#2B2118',
//   textSecondary: '#8A7A6D',
//   border: '#F0E6DA',
// };

// // Gallery settings
// const MAX_VISIBLE = 3; // 1 expanded + up to 2 narrow pills
// const GALLERY_HEIGHT = 220;
// const PILL_WIDTH = 28; // slightly thinner pills
// const MAIN_MIN_WIDTH = 180; // main image never shrinks below this
// const SWIPE_THRESHOLD = 50;
// const TAP_TOLERANCE = 8;

// // =====================================================================
// // HELPERS
// // =====================================================================
// const reverseGeocodeCity = async (lat, lng) => {
//   try {
//     const response = await fetch(
//       `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=10&addressdetails=1`
//     );
//     const data = await response.json();

//     const addr = data?.address || {};

//     const city =
//       addr.city ||
//       addr.town ||
//       addr.village ||
//       addr.municipality ||
//       addr.county ||
//       addr.state_district ||
//       addr.state ||
//       null;

//     return city;
//   } catch (error) {
//     console.error('Reverse geocoding error:', error);
//     return null;
//   }
// };

// // pretty BHK label — matches BHKDescription's `prettyBhk`
// const prettyBhk = (raw) => {
//   if (!raw) return 'Unit';
//   return String(raw).replace(/(\d+\+?)\s*BHK/i, '$1 BHK').trim();
// };

// // numeric sort for BHK labels
// const BHK_SORT = (a, b) => {
//   const num = (s) => {
//     const m = String(s || '').match(/(\d+)/);
//     return m ? parseInt(m[1], 10) : 999;
//   };
//   return num(a) - num(b);
// };

// // Suffix shown beside the BHK type (Apartment / Villa / Independent House only)
// const getTypeLabel = (bhk, propertyType) => {
//   const t = String(propertyType || '').toLowerCase();
//   const suffix = t.includes('apartment')
//     ? 'Flats'
//     : t.includes('villa')
//       ? 'Villa'
//       : t.includes('independent')
//         ? 'Independent House'
//         : '';
//   return suffix ? `${bhk} ${suffix}` : bhk;
// };

// const NewList = () => {
//   const navigate = useNavigate();

//   const [searchQuery, setSearchQuery] = useState('');
//   const [properties, setProperties] = useState([]);
//   const [activeCategory, setActiveCategory] = useState('All');
//   const [activeImageIndex, setActiveImageIndex] = useState({});
//   const [loading, setLoading] = useState(true);
//   useScrollRestoration(!loading);

//   const [userCity, setUserCity] = useState('Bangalore');

//   // { [propertyId]: cartId } -> a property is "liked" if it has a cartId
//   const [cartIds, setCartIds] = useState({});
//   const pendingLikes = useRef(new Set()); // blocks double-taps while a request is in flight

//   // swipe / tap tracking
//   const touchStartX = useRef(null);
//   const touchEndX = useRef(null);
//   const isDragging = useRef(false);
//   const hasDragged = useRef(false); // true once the finger really moved (a swipe, not a tap)
//   const dragPropertyId = useRef(null);
//   const lastTouchAt = useRef(0); // used to ignore the mouse events a phone fires after a touch

//   const PROPERTIES_API = `${BASE_URL}/ad-properties/performance/?displaying_pannels=recommended_nearest&status=true`;

//   const getImageUrl = (imagePath) => {
//     if (!imagePath) return buildingImage;
//     if (imagePath.startsWith('http')) return imagePath;
//     return `${BASE_URL}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
//   };

//   const formatPrice = (price) => {
//     if (price === null || price === undefined || price === '') {
//       return 'Price on request';
//     }
//     const numericPrice = Number(price);
//     if (Number.isNaN(numericPrice) || numericPrice <= 0) {
//       return 'Price on request';
//     }
//     if (numericPrice >= 10000000) {
//       return `₹${(numericPrice / 10000000).toFixed(1)}Cr`;
//     }
//     if (numericPrice >= 100000) {
//       return `₹${(numericPrice / 100000).toFixed(1)}L`;
//     }
//     return `₹${numericPrice.toLocaleString('en-IN')}`;
//   };

//   const getPriceRange = (configurations) => {
//     if (!Array.isArray(configurations) || configurations.length === 0) {
//       return 'Price on request';
//     }

//     const prices = configurations
//       .map((c) => Number(c.price))
//       .filter((p) => !Number.isNaN(p) && p > 0);

//     if (prices.length === 0) return 'Price on request';

//     const minPrice = Math.min(...prices);
//     const maxPrice = Math.max(...prices);

//     if (minPrice === maxPrice) {
//       return formatPrice(minPrice);
//     }

//     return `${formatPrice(minPrice)} - ${formatPrice(maxPrice)}`;
//   };

//   const getPricePerSqft = (configurations) => {
//     if (!Array.isArray(configurations) || configurations.length === 0) {
//       return null;
//     }

//     for (const config of configurations) {
//       const price = Number(config.price);
//       const carpetArea = Number(config.carpet_area);

//       if (!Number.isNaN(price) && !Number.isNaN(carpetArea) && carpetArea > 0) {
//         const perSqft = price / carpetArea;
//         return `₹${Math.round(perSqft).toLocaleString('en-IN')}/sq.ft`;
//       }
//     }

//     return null;
//   };

//   const getArea = (item) => {
//     if (!item.site_area) return null;
//     let unit = 'sq ft';
//     if (item.units) {
//       if (item.units.toLowerCase() === 'ft') unit = 'Sq ft';
//       else unit = item.units;
//     }
//     return `${item.site_area} ${unit}`;
//   };

//   const formatPossessionDate = (dateStr) => {
//     if (!dateStr) return 'Ready to Move';
//     const date = new Date(dateStr);
//     if (Number.isNaN(date.getTime())) return 'Ready to Move';
//     return date.toLocaleDateString('en-IN', {
//       month: 'short',
//       year: 'numeric',
//     });
//   };

//   const getLocation = (item) => {
//     return (
//       item.location ||
//       item.address ||
//       item.city ||
//       item.landmark ||
//       'Location not specified'
//     );
//   };

//   const getBuilderName = (item) => {
//     if (item.builder_details?.builder_name) {
//       return item.builder_details.builder_name;
//     }

//     const fullName = [item.user_first_name, item.user_last_name]
//       .filter(Boolean)
//       .join(' ')
//       .trim();

//     return fullName || item.posted_by?.replace(/"/g, '') || 'Verified Owner';
//   };

//   const getBhkTypes = (item) => {
//     if (Array.isArray(item.configurations) && item.configurations.length > 0) {
//       const bhks = item.configurations.map((c) => c.bhk_type).filter(Boolean);
//       const unique = [...new Set(bhks)];
//       if (unique.length > 0) return `${unique.join(', ')}BHK Flats`;
//     }
//     if (item.bhk_type) return `${item.bhk_type} Flats`;
//     return item.category_name || item.property_type || 'Flats';
//   };

//   // build BHK config list for the pill rows (sorted)
//   const getBhkConfigs = (item) => {
//     if (!Array.isArray(item.configurations)) return [];
//     return item.configurations
//       .filter((c) => c && (c.bhk_type || c.price !== undefined))
//       .map((c, i) => ({
//         id: c.id ?? `cfg-${i}`,
//         bhk_type: prettyBhk(c.bhk_type),
//         price: c.price,
//       }))
//       .sort((a, b) => BHK_SORT(a.bhk_type, b.bhk_type));
//   };

//   const fetchProperties = async () => {
//     try {
//       setLoading(true);
//       const propertyTypeParam =
//         activeCategory === 'All'
//           ? ''
//           : `&property_type=${encodeURIComponent(activeCategory)}`;

//       const response = await axios.get(
//         `${PROPERTIES_API}${propertyTypeParam}`
//       );

//       const apiData = response.data?.data || [];

//       const parsedProperties = apiData.map((item) => {
//         let images = [];
//         if (Array.isArray(item.hero_images) && item.hero_images.length > 0) {
//           images = [...item.hero_images]
//             .sort((a, b) => (a.order || 0) - (b.order || 0))
//             .map((image) => getImageUrl(image.image));
//         }
//         if (images.length === 0) images = [buildingImage, buildingImage];
//         if (images.length === 1) images = [images[0], images[0]];

//         const category =
//           item.category_name || item.property_type || 'Property';

//         const formattedPrice = getPriceRange(item.configurations);
//         const pricePerSqft = getPricePerSqft(item.configurations);
//         const bhkConfigs = getBhkConfigs(item);

//         return {
//           id: item.property_id,
//           title: item.property_name || item.property_type || category || 'Property',
//           category,
//           propertyType: item.property_type,
//           builder: getBuilderName(item),
//           location: getLocation(item),
//           price: Number(item.price) || 0,
//           formattedPrice,
//           address: item.address || '',
//           pricePerSqft,
//           area: getArea(item),
//           possession: item.possession_date,
//           bhkText: getBhkTypes(item),
//           bhkConfigs,
//           images,
//           lat: item.lat,
//           long: item.long,
//           propertyData: item,
//         };
//       });

//       setProperties(parsedProperties);
//     } catch (error) {
//       console.error('Error fetching properties:', {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status,
//       });
//       setProperties([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProperties();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [activeCategory]);

//   useEffect(() => {
//     const loadUserCity = async () => {
//       const cachedCity = localStorage.getItem('userCity');
//       if (cachedCity) {
//         setUserCity(cachedCity);
//         return;
//       }

//       const cachedLat = localStorage.getItem('userLatitude');
//       const cachedLng = localStorage.getItem('userLongitude');

//       if (cachedLat && cachedLng) {
//         const city = await reverseGeocodeCity(cachedLat, cachedLng);
//         if (city) {
//           setUserCity(city);
//           localStorage.setItem('userCity', city);
//         }
//         return;
//       }

//       if (!navigator.geolocation) return;

//       navigator.geolocation.getCurrentPosition(
//         async (position) => {
//           const { latitude, longitude } = position.coords;
//           localStorage.setItem('userLatitude', latitude.toString());
//           localStorage.setItem('userLongitude', longitude.toString());
//           const city = await reverseGeocodeCity(latitude, longitude);
//           if (city) {
//             setUserCity(city);
//             localStorage.setItem('userCity', city);
//           }
//         },
//         (error) => {
//           console.warn('Geolocation error in NewList:', error.message);
//         },
//         {
//           enableHighAccuracy: false,
//           timeout: 10000,
//           maximumAge: 600000,
//         }
//       );
//     };

//     loadUserCity();
//   }, []);

//   // -------------------------------------------------------------------
//   // Wishlist (user cart) handling
//   // -------------------------------------------------------------------

//   // Load the user's cart and match it with the properties by ad_property id
//   const loadUserCart = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/get-user-cart/${getUserId()}/`);
//       const raw = res.data;
//       const list = Array.isArray(raw) ? raw : raw?.data || raw?.results || [];

//       const map = {};
//       list.forEach((item) => {
//         if (item.property_source && item.property_source !== 'AdProperty') return;

//         const adId =
//           item.ad_property && typeof item.ad_property === 'object'
//             ? item.ad_property.property_id ?? item.ad_property.id
//             : item.ad_property;

//         if (adId !== null && adId !== undefined) {
//           map[String(adId)] = item.cart_id;
//         }
//       });

//       setCartIds(map);
//     } catch (error) {
//       console.error('Error loading user cart:', error.message);
//     }
//   };

//   useEffect(() => {
//     loadUserCart();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const removeFromCart = (cartId) => axios.delete(`${USER_CART_API}${cartId}/`);

//   const logActivity = (propertyId, status) =>
//     axios
//       .post(ACTIVITIES_API, {
//         user_id: getUserId(),
//         property_source: 'AdProperty',
//         ad_property: propertyId,
//         activity_type: 'Liked',
//         activity_as: 'Buyer',
//         status,
//       })
//       .catch((err) => console.error('Activity log failed:', err.message));

//   const toggleLike = async (propertyId, e) => {
//     e.stopPropagation();

//     const key = String(propertyId);
//     if (pendingLikes.current.has(key)) return;
//     pendingLikes.current.add(key);

//     const existingCartId = cartIds[key];

//     try {
//       if (existingCartId) {
//         // ---- UNLIKE: remove from cart ----
//         setCartIds((prev) => {
//           const next = { ...prev };
//           delete next[key];
//           return next;
//         });

//         try {
//           await removeFromCart(existingCartId);
//           logActivity(propertyId, false);
//         } catch (error) {
//           // roll back
//           setCartIds((prev) => ({ ...prev, [key]: existingCartId }));
//           console.error(
//             'Error removing from cart:',
//             error.response?.data || error.message
//           );
//         }
//       } else {
//         // ---- LIKE: add to cart ----
//         setCartIds((prev) => ({ ...prev, [key]: 'pending' }));

//         try {
//           const res = await axios.post(USER_CART_API, {
//             user_id: getUserId(),
//             property_source: 'AdProperty',
//             ad_property: propertyId,
//             activity_as: null,
//             status: true,
//           });

//           const newCartId = res.data?.cart_id ?? res.data?.data?.cart_id;

//           if (newCartId) {
//             setCartIds((prev) => ({ ...prev, [key]: newCartId }));
//           } else {
//             // no cart_id in the response: re-sync so we have the real id for removal
//             await loadUserCart();
//           }
//           logActivity(propertyId, true);
//         } catch (error) {
//           // roll back
//           setCartIds((prev) => {
//             const next = { ...prev };
//             delete next[key];
//             return next;
//           });
//           console.error(
//             'Error adding to cart:',
//             error.response?.data || error.message
//           );
//         }
//       }
//     } finally {
//       pendingLikes.current.delete(key);
//     }
//   };

//   // -------------------------------------------------------------------
//   // Swipe handling for the image gallery
//   // -------------------------------------------------------------------
//   const handleDragStart = (propertyId, e) => {
//     const isTouch = !!e.touches;

//     if (isTouch) {
//       lastTouchAt.current = Date.now();
//     } else if (Date.now() - lastTouchAt.current < 700) {
//       // phones fire fake mouse events right after a touch; ignore them
//       return;
//     }

//     const clientX = isTouch ? e.touches[0].clientX : e.clientX;
//     touchStartX.current = clientX;
//     touchEndX.current = clientX;
//     isDragging.current = true;
//     hasDragged.current = false; // new gesture: assume it's a tap until it moves
//     dragPropertyId.current = propertyId;
//   };

//   const handleDragMove = (propertyId, e) => {
//     if (!isDragging.current || dragPropertyId.current !== propertyId) return;
//     if (touchStartX.current === null) return;

//     const clientX = e.touches ? e.touches[0].clientX : e.clientX;
//     touchEndX.current = clientX;

//     if (Math.abs(clientX - touchStartX.current) > TAP_TOLERANCE) {
//       hasDragged.current = true; // real swipe, not a tap
//     }
//   };

//   const handleDragEnd = (propertyId, totalImages) => {
//     if (!isDragging.current || dragPropertyId.current !== propertyId) return;

//     if (touchStartX.current !== null) {
//       const diff = (touchEndX.current ?? 0) - touchStartX.current;

//       if (Math.abs(diff) > SWIPE_THRESHOLD) {
//         if (diff < 0) {
//           // swipe left -> next image
//           setActiveImageIndex((prev) => ({
//             ...prev,
//             [propertyId]: ((prev[propertyId] || 0) + 1) % totalImages,
//           }));
//         } else {
//           // swipe right -> previous image
//           setActiveImageIndex((prev) => ({
//             ...prev,
//             [propertyId]:
//               ((prev[propertyId] || 0) - 1 + totalImages) % totalImages,
//           }));
//         }
//       }
//     }

//     touchStartX.current = null;
//     touchEndX.current = null;
//     isDragging.current = false;
//     dragPropertyId.current = null;
//     // NOTE: hasDragged is intentionally NOT reset here, so the click that
//     // follows a swipe can still be blocked. It resets on the next touch.
//   };

//   const truncateText = (text, maxLength) => {
//     if (!text) return '';
//     return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
//   };

//   const categoryPills = [
//     'All',
//     'Apartments',
//     'Commercial Spaces',
//     'Independent Houses',
//     'Villas',
//     'Plots/Lands',
//   ];

//   const filteredProperties = properties.filter((property) => {
//     const search = searchQuery.toLowerCase();
//     return (
//       property.title?.toLowerCase().includes(search) ||
//       property.location?.toLowerCase().includes(search) ||
//       property.category?.toLowerCase().includes(search) ||
//       property.builder?.toLowerCase().includes(search)
//     );
//   });

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           backgroundColor: '#FDFBF7',
//           minHeight: '100vh',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           gap: 3,
//         }}
//       >
//         <CircularProgress size={40} thickness={5} sx={{ color: '#C8873D' }} />
//         <Typography variant="body1" sx={{ color: '#000000', fontWeight: 600 }}>
//           Loading properties...
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ backgroundColor: '#d4caca', minHeight: '100vh' }}>
//       {/* Sticky Search Bar */}
//       <Box
//         sx={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           zIndex: 1200,
//           display: 'flex',
//           alignItems: 'center',
//           gap: 1,
//           px: 1,
//           py: 1,
//           backgroundColor: '#FDFBF7',
//         }}
//       >
//         <Box sx={{ flex: 1 }}>
//           <CustomSearchBar
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//         </Box>
//       </Box>

//       {/* Main Content */}
//       <Box sx={{ pt: { xs: '50px', sm: '90px' }, pb: 8 }}>
//         {/* Header */}
//         <Box
//           sx={{
//             px: 2,
//             display: 'flex',
//             alignItems: 'flex-start',
//             justifyContent: 'space-between',
//             mb: 1,
//           }}
//         >
//           <Box>
//             <Typography
//               sx={{
//                 fontWeight: 700,
//                 color: '#1a1a1a',
//                 fontSize: '1.15rem',
//                 lineHeight: 1.2,
//                 position: 'relative',
//                 display: 'inline-block',
//                 pb: 0.5,
//                 '&::after': {
//                   content: '""',
//                   position: 'absolute',
//                   left: 0,
//                   bottom: 0,
//                   width: '60%',
//                   height: '2px',
//                   backgroundColor: '#B88A5C',
//                 },
//               }}
//             >
//               Recommended Properties
//             </Typography>
//           </Box>

//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
//             <East sx={{ fontSize: 16, color: '#B88A5C' }} />
//             <LocationOn sx={{ fontSize: 16, color: '#B88A5C' }} />
//             <Typography
//               sx={{
//                 fontWeight: 700,
//                 color: '#1a1a1a',
//                 fontSize: '0.85rem',
//                 textTransform: 'capitalize',
//               }}
//             >
//               {userCity}
//             </Typography>
//           </Box>
//         </Box>

//         {/* Category Pills */}
//         <Box
//           sx={{
//             display: 'flex',
//             gap: 1.2,
//             px: 0.5,
//             pb: 0.5,
//             overflowX: 'auto',
//             whiteSpace: 'nowrap',
//             flexWrap: 'nowrap',
//             '&::-webkit-scrollbar': { display: 'none' },
//             scrollbarWidth: 'none',
//           }}
//         >
//           {categoryPills.map((cat) => {
//             const isActive = activeCategory === cat;
//             return (
//               <Chip
//                 key={cat}
//                 label={cat}
//                 onClick={() => setActiveCategory(cat)}
//                 sx={{
//                   fontWeight: 600,
//                   fontSize: '0.85rem',
//                   borderRadius: '24px',
//                   width: 'fit-content',
//                   minWidth: 'fit-content',
//                   maxWidth: 'none',
//                   flexShrink: 0,
//                   height: 26,
//                   backgroundColor: isActive ? '#B88A5C' : '#FFFFFF',
//                   color: isActive ? '#FFFFFF' : '#4A4A4A',
//                   border: isActive ? 'none' : '1px solid #D3CBC0',
//                   boxShadow: isActive
//                     ? '0 2px 8px rgba(184,138,92,0.35)'
//                     : 'none',
//                   '& .MuiChip-label': {
//                     display: 'block',
//                     whiteSpace: 'nowrap',
//                     overflow: 'visible',
//                     textOverflow: 'unset',
//                     maxWidth: 'none',
//                     px: 1.5,
//                   },
//                   '&:hover': {
//                     backgroundColor: isActive ? '#A67B52' : '#F5EFE6',
//                   },
//                 }}
//               />
//             );
//           })}
//         </Box>

//         {/* Property Cards */}
//         {filteredProperties.length > 0 ? (
//           filteredProperties.map((property) => {
//             const totalImages = property.images.length;
//             const currentIndex =
//               (activeImageIndex[property.id] || 0) % totalImages;

//             // Only show as many slots as we actually have images for.
//             // e.g. 2 images  -> 1 main + 1 pill
//             //      3 images  -> 1 main + 2 pills
//             //      5+ images -> 1 main + 2 pills (window scrolls)
//             const visibleCount = Math.min(totalImages, MAX_VISIBLE);

//             // Center the window around the current image, but clamp to bounds
//             const windowStart = Math.max(
//               0,
//               Math.min(
//                 currentIndex - Math.floor(visibleCount / 2),
//                 totalImages - visibleCount
//               )
//             );

//             const isLiked = Boolean(cartIds[String(property.id)]);

//             return (
//               <Card
//                 key={property.id}
//                 onClick={() => {
//                   // a swipe also triggers a click on mobile/desktop; ignore it
//                   if (hasDragged.current) return;
//                   navigate(`/new-launching-properties/${property.id}`, {
//                     state: {
//                       propertyId: property.id,
//                       property: property.propertyData,
//                     },
//                   });
//                 }}
//                 sx={{
//                   mx: 1,
//                   mb: 1,
//                   borderRadius: '18px',
//                   boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
//                   overflow: 'hidden',
//                   cursor: 'pointer',
//                   backgroundColor: '#FFFFFF',
//                   border: '1px solid #F0EBE4',
//                   p: 1,
//                   transition: 'transform 0.2s ease-in-out',
//                   '&:hover': { transform: 'scale(1.01)' },
//                 }}
//               >
//                 {/* ═══════════════════════════════════════════════════
//                     Expanding-strip gallery
//                     active image = wide, others = narrow pills.
//                     Tap / swipe a pill and it expands into the main slot.
//                     ═══════════════════════════════════════════════════ */}
//                 <Box
//                   onTouchStart={(e) => handleDragStart(property.id, e)}
//                   onTouchMove={(e) => handleDragMove(property.id, e)}
//                   onTouchEnd={() => handleDragEnd(property.id, totalImages)}
//                   onTouchCancel={() => handleDragEnd(property.id, totalImages)}
//                   onMouseDown={(e) => handleDragStart(property.id, e)}
//                   onMouseMove={(e) => handleDragMove(property.id, e)}
//                   onMouseUp={() => handleDragEnd(property.id, totalImages)}
//                   onMouseLeave={() => {
//                     if (
//                       isDragging.current &&
//                       dragPropertyId.current === property.id
//                     ) {
//                       handleDragEnd(property.id, totalImages);
//                     }
//                   }}
//                   sx={{
//                     position: 'relative',
//                     display: 'flex',
//                     height: GALLERY_HEIGHT,
//                     userSelect: 'none',
//                     WebkitUserSelect: 'none',
//                     WebkitTapHighlightColor: 'transparent',
//                     touchAction: 'pan-y',
//                     cursor: 'grab',
//                   }}
//                 >
//                   {property.images.map((img, idx) => {
//                     const isMain = idx === currentIndex;
//                     const inWindow =
//                       idx >= windowStart && idx < windowStart + MAX_VISIBLE;
//                     const isPill = inWindow && !isMain;

//                     return (
//                       <Box
//                         key={idx}
//                         onClick={
//                           isPill
//                             ? (e) => {
//                                 e.stopPropagation();
//                                 if (hasDragged.current) return;
//                                 setActiveImageIndex((prev) => ({
//                                   ...prev,
//                                   [property.id]: idx,
//                                 }));
//                               }
//                             : undefined
//                         }
//                         sx={{
//                           position: 'relative',
//                           height: '100%',
//                           overflow: 'hidden',
//                           borderRadius: isMain ? '22px' : '18px',
//                           // Main image always keeps at least MAIN_MIN_WIDTH.
//                           // Pills are fixed-narrow. Hidden images collapse to 0 width.
//                           flexGrow: isMain ? 1 : 0,
//                           flexShrink: isMain ? 1 : 0,
//                           flexBasis: isMain
//                             ? `calc(100% - ${
//                                 Math.max(0, visibleCount - 1) * (PILL_WIDTH + 6)
//                               }px)`
//                             : isPill
//                               ? `${PILL_WIDTH}px`
//                               : '0px',
//                           minWidth: isMain ? `${MAIN_MIN_WIDTH}px` : 0,
//                           maxWidth: isPill ? `${PILL_WIDTH}px` : 'none',
//                           ml: inWindow && idx !== windowStart ? '6px' : 0,
//                           opacity: inWindow ? 1 : 0,
//                           pointerEvents: inWindow ? 'auto' : 'none',
//                           cursor: isPill ? 'pointer' : 'inherit',
//                           transition:
//                             'flex-basis 0.5s cubic-bezier(0.4,0,0.2,1), margin 0.5s cubic-bezier(0.4,0,0.2,1), opacity 0.4s ease, border-radius 0.5s ease',
//                         }}
//                       >
//                         {/* fixed-width image so it doesn't squash while resizing */}
//                         <Box
//                           component="img"
//                           src={img || buildingImage}
//                           alt={`${property.title}-${idx}`}
//                           draggable={false}
//                           sx={{
//                             position: 'absolute',
//                             inset: 0,
//                             width: '100%',
//                             height: '100%',
//                             objectFit: 'cover',
//                             objectPosition: 'center',
//                             pointerEvents: 'none',
//                             // keep the image from squashing while flex animates
//                             minWidth: '100%',
//                           }}
//                         />

//                         {/* Pill: soft fade + number badge */}
//                         {isPill && (
//                           <>
//                             <Box
//                               sx={{
//                                 position: 'absolute',
//                                 inset: 0,
//                                 background:
//                                   'linear-gradient(180deg, rgba(255,255,255,0) 40%, rgba(255,255,255,0.35) 100%)',
//                               }}
//                             />
//                             <Box
//                               sx={{
//                                 position: 'absolute',
//                                 bottom: 8,
//                                 left: '50%',
//                                 transform: 'translateX(-50%)',
//                                 width: 22,
//                                 height: 22,
//                                 borderRadius: '50%',
//                                 bgcolor: '#fff',
//                                 color: COLORS.primary,
//                                 fontSize: 11,
//                                 fontWeight: 700,
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
//                               }}
//                             >
//                               {idx + 1}
//                             </Box>
//                           </>
//                         )}

//                         {/* Main: bottom gradient + title/builder + like button */}
//                         {isMain && (
//                           <>
//                             <Box
//                               sx={{
//                                 position: 'absolute',
//                                 inset: 0,
//                                 background:
//                                   'linear-gradient(180deg, rgba(0,0,0,0) 55%, rgba(0,0,0,0.6) 100%)',
//                               }}
//                             />
//                             <Box
//                               sx={{
//                                 position: 'absolute',
//                                 left: 10,
//                                 bottom: 10,
//                                 right: 10,
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: 1,
//                               }}
//                             >
//                               <Box
//                                 sx={{
//                                   width: 26,
//                                   height: 26,
//                                   flexShrink: 0,
//                                   borderRadius: '50%',
//                                   bgcolor: '#fff',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   justifyContent: 'center',
//                                 }}
//                               >
//                                 <LocationOn
//                                   sx={{ fontSize: 16, color: COLORS.primary }}
//                                 />
//                               </Box>
//                               <Box sx={{ minWidth: 0 }}>
//                                 <Typography
//                                   noWrap
//                                   sx={{
//                                     color: '#fff',
//                                     fontWeight: 700,
//                                     fontSize: '0.85rem',
//                                     lineHeight: 1.2,
//                                   }}
//                                 >
//                                   {truncateText(property.title, 22)}
//                                 </Typography>
//                                 <Typography
//                                   noWrap
//                                   sx={{
//                                     color: 'rgba(255,255,255,0.85)',
//                                     fontSize: '0.7rem',
//                                     lineHeight: 1.2,
//                                   }}
//                                 >
//                                   {property.builder}
//                                 </Typography>
//                               </Box>
//                             </Box>

//                             <IconButton
//                               size="small"
//                               onMouseDown={(e) => e.stopPropagation()}
//                               onTouchStart={(e) => e.stopPropagation()}
//                               onClick={(e) => toggleLike(property.id, e)}
//                               sx={{
//                                 position: 'absolute',
//                                 top: 10,
//                                 right: 10,
//                                 bgcolor: 'rgba(255,255,255,0.9)',
//                                 width: 32,
//                                 height: 32,
//                                 boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
//                                 '&:hover': { bgcolor: '#fff' },
//                               }}
//                             >
//                               {isLiked ? (
//                                 <Favorite
//                                   sx={{ fontSize: 17, color: '#e0432b' }}
//                                 />
//                               ) : (
//                                 <FavoriteBorder
//                                   sx={{ fontSize: 17, color: '#333' }}
//                                 />
//                               )}
//                             </IconButton>
//                           </>
//                         )}
//                       </Box>
//                     );
//                   })}
//                 </Box>

//                 {/* Property Details */}
//                 <Box sx={{ px: 1, pt: 1.5, pb: 0.5 }}>
//                   {/* Title + Price Range */}
//                   <Box
//                     display="flex"
//                     justifyContent="space-between"
//                     alignItems="flex-start"
//                     mb={0.5}
//                     gap={1}
//                   >
//                     <Typography
//                       fontWeight={700}
//                       noWrap
//                       sx={{ flex: 1, fontSize: '1.05rem', color: '#222' }}
//                     >
//                       {truncateText(property.title, 22)}
//                     </Typography>

//                     <Typography
//                       fontWeight={700}
//                       noWrap
//                       sx={{
//                         fontSize: '1.05rem',
//                         color: '#A97028',
//                         flexShrink: 0,
//                       }}
//                     >
//                       {property.formattedPrice}
//                     </Typography>
//                   </Box>

//                   {/* Builder + Price per sqft */}
//                   <Box
//                     display="flex"
//                     justifyContent="space-between"
//                     alignItems="center"
//                     mb={0.8}
//                     gap={1}
//                   >
//                     <Typography
//                       noWrap
//                       sx={{
//                         color: '#B88A5C',
//                         fontWeight: 500,
//                         flex: 1,
//                         fontSize: '0.82rem',
//                       }}
//                     >
//                       {property.builder}
//                     </Typography>

//                     {property.pricePerSqft && (
//                       <Typography
//                         noWrap
//                         sx={{
//                           fontSize: '0.8rem',
//                           color: '#8A8A8A',
//                           flexShrink: 0,
//                         }}
//                       >
//                         {property.pricePerSqft}
//                       </Typography>
//                     )}
//                   </Box>

//                   {/* Location */}
//                   <Box display="flex" alignItems="center" mb={1} gap={0.5}>
//                     <LocationOn sx={{ fontSize: 16, color: '#8A8A8A' }} />
//                     <Typography
//                       noWrap
//                       sx={{ flex: 1, fontSize: '0.82rem', color: '#8A8A8A' }}
//                     >
//                       {property.address}
//                     </Typography>
//                   </Box>

//                   <Box sx={{ borderTop: '1px solid #EAEAEA', mb: 1.2 }} />

//                   {/* ═══════════════════════════════════════════════════════
//                       BHK config rows — dedupe by BHK type,
//                       keep the LOWEST price for each unique BHK.
//                       ═══════════════════════════════════════════════════════ */}
//                   {property.bhkConfigs &&
//                     property.bhkConfigs.length > 0 &&
//                     (() => {
//                       const uniqueMap = new Map();

//                       property.bhkConfigs.forEach((cfg) => {
//                         const key = cfg.bhk_type; // e.g. "1 BHK", "2 BHK"
//                         const price = Number(cfg.price);

//                         if (!uniqueMap.has(key)) {
//                           uniqueMap.set(key, { ...cfg });
//                         } else {
//                           const existing = uniqueMap.get(key);
//                           const existingPrice = Number(existing.price);

//                           if (
//                             !Number.isNaN(price) &&
//                             price > 0 &&
//                             (Number.isNaN(existingPrice) ||
//                               existingPrice <= 0 ||
//                               price < existingPrice)
//                           ) {
//                             uniqueMap.set(key, { ...cfg });
//                           }
//                         }
//                       });

//                       const uniqueConfigs = Array.from(uniqueMap.values()).sort(
//                         (a, b) => BHK_SORT(a.bhk_type, b.bhk_type)
//                       );

//                       return (
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             gap: 0.8,
//                             mb: 1.2,
//                           }}
//                         >
//                           {uniqueConfigs.map((cfg, idx) => (
//                             <Paper
//                               key={cfg.id ?? `${cfg.bhk_type}-${idx}`}
//                               elevation={0}
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 navigate(
//                                   `/new-launching-properties/${property.id}`,
//                                   {
//                                     state: {
//                                       propertyId: property.id,
//                                       property: property.propertyData,
//                                     },
//                                   }
//                                 );
//                               }}
//                               sx={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center',
//                                 px: 1.2,
//                                 py: 0.8,
//                                 borderRadius: 2,
//                                 cursor: 'pointer',
//                                 border: `1px solid ${COLORS.border}`,
//                                 boxShadow: 'none',
//                                 bgcolor: 'white',
//                                 transition: 'background 0.15s ease',
//                                 '&:hover': { bgcolor: '#FAFAFA' },
//                               }}
//                             >
//                               <Typography
//                                 sx={{
//                                   fontSize: '14px',
//                                   fontWeight: 700,
//                                   color: COLORS.textDark,
//                                 }}
//                               >
//                                 {getTypeLabel(cfg.bhk_type, property.propertyType)}
//                               </Typography>

//                               <Box
//                                 sx={{
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   gap: 0.6,
//                                 }}
//                               >
//                                 <Typography
//                                   sx={{
//                                     fontSize: '12.5px',
//                                     fontWeight: 600,
//                                     color: COLORS.primary,
//                                   }}
//                                 >
//                                   {cfg.price !== undefined && cfg.price !== null
//                                     ? `Starting at ${formatPrice(cfg.price)}`
//                                     : 'Price on Request'}
//                                 </Typography>
//                                 <ChevronRight
//                                   sx={{
//                                     color: COLORS.textSecondary,
//                                     fontSize: 18,
//                                   }}
//                                 />
//                               </Box>
//                             </Paper>
//                           ))}
//                         </Box>
//                       );
//                     })()}

//                   {/* Property type (left) + Possession (right) */}
//                   <Box
//                     display="flex"
//                     justifyContent="space-between"
//                     alignItems="center"
//                     gap={1}
//                   >
//                     <Typography
//                       noWrap
//                       sx={{
//                         fontSize: '0.8rem',
//                         color: '#A97028',
//                         fontWeight: 600,
//                         flex: 1,
//                       }}
//                     >
//                       {property.propertyType}
//                     </Typography>

//                     <Typography
//                       noWrap
//                       sx={{ fontSize: '0.8rem', color: '#555', flexShrink: 0 }}
//                     >
//                       Possession:{' '}
//                       <Box
//                         component="span"
//                         sx={{ color: '#A97028', fontWeight: 600 }}
//                       >
//                         {formatPossessionDate(property.possession)}
//                       </Box>
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Card>
//             );
//           })
//         ) : (
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               height: 200,
//               px: 2,
//             }}
//           >
//             <Typography>No properties found matching your search.</Typography>
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default NewList;


import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useScrollRestoration from '../../../hooks/useScrollRestoration';
import {
  Box,
  Card,
  Typography,
  IconButton,
  Chip,
  CircularProgress,
  Paper,
} from '@mui/material';

import {
  FavoriteBorder,
  Favorite,
  LocationOn,
  East,
  ChevronRight,
} from '@mui/icons-material';

import axios from 'axios';

import buildingImage from './../../../Images/house.jpeg';
import CustomSearchBar from './../Lease Module/CustomSearch';

// --- IMPORT THE SUCCESS MODAL ---
// Adjust the path based on where your AlertModal is located
import AlertModal from '../Buy Module/AlertModal'; 

// =====================================================================
// API CONSTANTS
// =====================================================================
const BASE_URL = 'https://landnest.net:81';
const ACTIVITIES_API = `${BASE_URL}/activities/`;
const USER_CART_API = `${BASE_URL}/user-cart/`;

// Replace with your real logged-in user (context, redux, localStorage...)
const getUserId = () => Number(localStorage.getItem('user_id'));

// =====================================================================
// THEME COLORS (matched to BHKDescription)
// =====================================================================
const COLORS = {
  primary: '#8B4A2B',
  primaryDark: '#6B3620',
  primaryLight: '#FBEEE0',
  textDark: '#2B2118',
  textSecondary: '#8A7A6D',
  border: '#F0E6DA',
};

// Gallery settings
const MAX_VISIBLE = 3; // 1 expanded + up to 2 narrow pills
const GALLERY_HEIGHT = 220;
const PILL_WIDTH = 28; // slightly thinner pills
const MAIN_MIN_WIDTH = 180; // main image never shrinks below this
const SWIPE_THRESHOLD = 50;
const TAP_TOLERANCE = 8;

// =====================================================================
// HELPERS
// =====================================================================
const reverseGeocodeCity = async (lat, lng) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=10&addressdetails=1`
    );
    const data = await response.json();

    const addr = data?.address || {};

    const city =
      addr.city ||
      addr.town ||
      addr.village ||
      addr.municipality ||
      addr.county ||
      addr.state_district ||
      addr.state ||
      null;

    return city;
  } catch (error) {
    console.error('Reverse geocoding error:', error);
    return null;
  }
};

// pretty BHK label — matches BHKDescription's `prettyBhk`
const prettyBhk = (raw) => {
  if (!raw) return 'Unit';
  return String(raw).replace(/(\d+\+?)\s*BHK/i, '$1 BHK').trim();
};

// numeric sort for BHK labels
const BHK_SORT = (a, b) => {
  const num = (s) => {
    const m = String(s || '').match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 999;
  };
  return num(a) - num(b);
};

// Suffix shown beside the BHK type (Apartment / Villa / Independent House only)
const getTypeLabel = (bhk, propertyType) => {
  const t = String(propertyType || '').toLowerCase();
  const suffix = t.includes('apartment')
    ? 'Flats'
    : t.includes('villa')
      ? 'Villa'
      : t.includes('independent')
        ? 'Independent House'
        : '';
  return suffix ? `${bhk} ${suffix}` : bhk;
};

const NewList = () => {
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState('');
  const [properties, setProperties] = useState([]);
  const [activeCategory, setActiveCategory] = useState('All');
  const [activeImageIndex, setActiveImageIndex] = useState({});
  const [loading, setLoading] = useState(true);
  useScrollRestoration(!loading);

  const [userCity, setUserCity] = useState('Bangalore');

  // { [propertyId]: cartId } -> a property is "liked" if it has a cartId
  const [cartIds, setCartIds] = useState({});
  const pendingLikes = useRef(new Set()); // blocks double-taps while a request is in flight

  // --- NEW STATE FOR SUCCESS POPUP ---
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // swipe / tap tracking
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const isDragging = useRef(false);
  const hasDragged = useRef(false); // true once the finger really moved (a swipe, not a tap)
  const dragPropertyId = useRef(null);
  const lastTouchAt = useRef(0); // used to ignore the mouse events a phone fires after a touch

  const PROPERTIES_API = `${BASE_URL}/ad-properties/performance/?displaying_pannels=recommended_nearest&status=true`;

  const getImageUrl = (imagePath) => {
    if (!imagePath) return buildingImage;
    if (imagePath.startsWith('http')) return imagePath;
    return `${BASE_URL}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
  };

  const formatPrice = (price) => {
    if (price === null || price === undefined || price === '') {
      return 'Price on request';
    }
    const numericPrice = Number(price);
    if (Number.isNaN(numericPrice) || numericPrice <= 0) {
      return 'Price on request';
    }
    if (numericPrice >= 10000000) {
      return `₹${(numericPrice / 10000000).toFixed(1)}Cr`;
    }
    if (numericPrice >= 100000) {
      return `₹${(numericPrice / 100000).toFixed(1)}L`;
    }
    return `₹${numericPrice.toLocaleString('en-IN')}`;
  };

  const getPriceRange = (configurations) => {
    if (!Array.isArray(configurations) || configurations.length === 0) {
      return 'Price on request';
    }

    const prices = configurations
      .map((c) => Number(c.price))
      .filter((p) => !Number.isNaN(p) && p > 0);

    if (prices.length === 0) return 'Price on request';

    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);

    if (minPrice === maxPrice) {
      return formatPrice(minPrice);
    }

    return `${formatPrice(minPrice)} - ${formatPrice(maxPrice)}`;
  };

  const getPricePerSqft = (configurations) => {
    if (!Array.isArray(configurations) || configurations.length === 0) {
      return null;
    }

    for (const config of configurations) {
      const price = Number(config.price);
      const carpetArea = Number(config.carpet_area);

      if (!Number.isNaN(price) && !Number.isNaN(carpetArea) && carpetArea > 0) {
        const perSqft = price / carpetArea;
        return `₹${Math.round(perSqft).toLocaleString('en-IN')}/sq.ft`;
      }
    }

    return null;
  };

  const getArea = (item) => {
    if (!item.site_area) return null;
    let unit = 'sq ft';
    if (item.units) {
      if (item.units.toLowerCase() === 'ft') unit = 'Sq ft';
      else unit = item.units;
    }
    return `${item.site_area} ${unit}`;
  };

  const formatPossessionDate = (dateStr) => {
    if (!dateStr) return 'Ready to Move';
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return 'Ready to Move';
    return date.toLocaleDateString('en-IN', {
      month: 'short',
      year: 'numeric',
    });
  };

  const getLocation = (item) => {
    return (
      item.location ||
      item.address ||
      item.city ||
      item.landmark ||
      'Location not specified'
    );
  };

  const getBuilderName = (item) => {
    if (item.builder_details?.builder_name) {
      return item.builder_details.builder_name;
    }

    const fullName = [item.user_first_name, item.user_last_name]
      .filter(Boolean)
      .join(' ')
      .trim();

    return fullName || item.posted_by?.replace(/"/g, '') || 'Verified Owner';
  };

  const getBhkTypes = (item) => {
    if (Array.isArray(item.configurations) && item.configurations.length > 0) {
      const bhks = item.configurations.map((c) => c.bhk_type).filter(Boolean);
      const unique = [...new Set(bhks)];
      if (unique.length > 0) return `${unique.join(', ')}BHK Flats`;
    }
    if (item.bhk_type) return `${item.bhk_type} Flats`;
    return item.category_name || item.property_type || 'Flats';
  };

  // build BHK config list for the pill rows (sorted)
  const getBhkConfigs = (item) => {
    if (!Array.isArray(item.configurations)) return [];
    return item.configurations
      .filter((c) => c && (c.bhk_type || c.price !== undefined))
      .map((c, i) => ({
        id: c.id ?? `cfg-${i}`,
        bhk_type: prettyBhk(c.bhk_type),
        price: c.price,
      }))
      .sort((a, b) => BHK_SORT(a.bhk_type, b.bhk_type));
  };

  const fetchProperties = async () => {
    try {
      setLoading(true);
      const propertyTypeParam =
        activeCategory === 'All'
          ? ''
          : `&property_type=${encodeURIComponent(activeCategory)}`;

      const response = await axios.get(
        `${PROPERTIES_API}${propertyTypeParam}`
      );

      const apiData = response.data?.data || [];

      const parsedProperties = apiData.map((item) => {
        let images = [];
        if (Array.isArray(item.hero_images) && item.hero_images.length > 0) {
          images = [...item.hero_images]
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((image) => getImageUrl(image.image));
        }
        if (images.length === 0) images = [buildingImage, buildingImage];
        if (images.length === 1) images = [images[0], images[0]];

        const category =
          item.category_name || item.property_type || 'Property';

        const formattedPrice = getPriceRange(item.configurations);
        const pricePerSqft = getPricePerSqft(item.configurations);
        const bhkConfigs = getBhkConfigs(item);

        return {
          id: item.property_id,
          title: item.property_name || item.property_type || category || 'Property',
          category,
          propertyType: item.property_type,
          builder: getBuilderName(item),
          location: getLocation(item),
          price: Number(item.price) || 0,
          formattedPrice,
          address: item.address || '',
          pricePerSqft,
          area: getArea(item),
          possession: item.possession_date,
          bhkText: getBhkTypes(item),
          bhkConfigs,
          images,
          lat: item.lat,
          long: item.long,
          propertyData: item,
        };
      });

      setProperties(parsedProperties);
    } catch (error) {
      console.error('Error fetching properties:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      setProperties([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProperties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCategory]);

  useEffect(() => {
    const loadUserCity = async () => {
      const cachedCity = localStorage.getItem('userCity');
      if (cachedCity) {
        setUserCity(cachedCity);
        return;
      }

      const cachedLat = localStorage.getItem('userLatitude');
      const cachedLng = localStorage.getItem('userLongitude');

      if (cachedLat && cachedLng) {
        const city = await reverseGeocodeCity(cachedLat, cachedLng);
        if (city) {
          setUserCity(city);
          localStorage.setItem('userCity', city);
        }
        return;
      }

      if (!navigator.geolocation) return;

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          localStorage.setItem('userLatitude', latitude.toString());
          localStorage.setItem('userLongitude', longitude.toString());
          const city = await reverseGeocodeCity(latitude, longitude);
          if (city) {
            setUserCity(city);
            localStorage.setItem('userCity', city);
          }
        },
        (error) => {
          console.warn('Geolocation error in NewList:', error.message);
        },
        {
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 600000,
        }
      );
    };

    loadUserCity();
  }, []);

  // -------------------------------------------------------------------
  // Wishlist (user cart) handling
  // -------------------------------------------------------------------

  // Load the user's cart and match it with the properties by ad_property id
  const loadUserCart = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/get-user-cart/${getUserId()}/`);
      const raw = res.data;
      const list = Array.isArray(raw) ? raw : raw?.data || raw?.results || [];

      const map = {};
      list.forEach((item) => {
        if (item.property_source && item.property_source !== 'AdProperty') return;

        const adId =
          item.ad_property && typeof item.ad_property === 'object'
            ? item.ad_property.property_id ?? item.ad_property.id
            : item.ad_property;

        if (adId !== null && adId !== undefined) {
          map[String(adId)] = item.cart_id;
        }
      });

      setCartIds(map);
    } catch (error) {
      console.error('Error loading user cart:', error.message);
    }
  };

  useEffect(() => {
    loadUserCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeFromCart = (cartId) => axios.delete(`${USER_CART_API}${cartId}/`);

  const logActivity = (propertyId, status) =>
    axios
      .post(ACTIVITIES_API, {
        user_id: getUserId(),
        property_source: 'AdProperty',
        ad_property: propertyId,
        activity_type: 'Liked',
        activity_as: 'Buyer',
        status,
      })
      .catch((err) => console.error('Activity log failed:', err.message));

  const toggleLike = async (propertyId, e) => {
    e.stopPropagation();

    const key = String(propertyId);
    if (pendingLikes.current.has(key)) return;
    pendingLikes.current.add(key);

    const existingCartId = cartIds[key];

    try {
      if (existingCartId) {
        // ---- UNLIKE: remove from cart ----
        setCartIds((prev) => {
          const next = { ...prev };
          delete next[key];
          return next;
        });

        try {
          await removeFromCart(existingCartId);
          logActivity(propertyId, false);
        } catch (error) {
          // roll back
          setCartIds((prev) => ({ ...prev, [key]: existingCartId }));
          console.error(
            'Error removing from cart:',
            error.response?.data || error.message
          );
        }
      } else {
        // ---- LIKE: add to cart ----
        setCartIds((prev) => ({ ...prev, [key]: 'pending' }));

        try {
          const res = await axios.post(USER_CART_API, {
            user_id: getUserId(),
            property_source: 'AdProperty',
            ad_property: propertyId,
            activity_as: null,
            status: true,
          });

          const newCartId = res.data?.cart_id ?? res.data?.data?.cart_id;

          if (newCartId) {
            setCartIds((prev) => ({ ...prev, [key]: newCartId }));
          } else {
            // no cart_id in the response: re-sync so we have the real id for removal
            await loadUserCart();
          }
          logActivity(propertyId, true);

          // --- SHOW SUCCESS POPUP DIRECTLY ---
          setShowSuccessModal(true); 

        } catch (error) {
          // roll back
          setCartIds((prev) => {
            const next = { ...prev };
            delete next[key];
            return next;
          });
          console.error(
            'Error adding to cart:',
            error.response?.data || error.message
          );
        }
      }
    } finally {
      pendingLikes.current.delete(key);
    }
  };

  // -------------------------------------------------------------------
  // Swipe handling for the image gallery
  // -------------------------------------------------------------------
  const handleDragStart = (propertyId, e) => {
    const isTouch = !!e.touches;

    if (isTouch) {
      lastTouchAt.current = Date.now();
    } else if (Date.now() - lastTouchAt.current < 700) {
      // phones fire fake mouse events right after a touch; ignore them
      return;
    }

    const clientX = isTouch ? e.touches[0].clientX : e.clientX;
    touchStartX.current = clientX;
    touchEndX.current = clientX;
    isDragging.current = true;
    hasDragged.current = false; // new gesture: assume it's a tap until it moves
    dragPropertyId.current = propertyId;
  };

  const handleDragMove = (propertyId, e) => {
    if (!isDragging.current || dragPropertyId.current !== propertyId) return;
    if (touchStartX.current === null) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    touchEndX.current = clientX;

    if (Math.abs(clientX - touchStartX.current) > TAP_TOLERANCE) {
      hasDragged.current = true; // real swipe, not a tap
    }
  };

  const handleDragEnd = (propertyId, totalImages) => {
    if (!isDragging.current || dragPropertyId.current !== propertyId) return;

    if (touchStartX.current !== null) {
      const diff = (touchEndX.current ?? 0) - touchStartX.current;

      if (Math.abs(diff) > SWIPE_THRESHOLD) {
        if (diff < 0) {
          // swipe left -> next image
          setActiveImageIndex((prev) => ({
            ...prev,
            [propertyId]: ((prev[propertyId] || 0) + 1) % totalImages,
          }));
        } else {
          // swipe right -> previous image
          setActiveImageIndex((prev) => ({
            ...prev,
            [propertyId]:
              ((prev[propertyId] || 0) - 1 + totalImages) % totalImages,
          }));
        }
      }
    }

    touchStartX.current = null;
    touchEndX.current = null;
    isDragging.current = false;
    dragPropertyId.current = null;
  };

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const categoryPills = [
    'All',
    'Apartments',
    'Commercial Spaces',
    'Independent Houses',
    'Villas',
    'Plots/Lands',
  ];

  const filteredProperties = properties.filter((property) => {
    const search = searchQuery.toLowerCase();
    return (
      property.title?.toLowerCase().includes(search) ||
      property.location?.toLowerCase().includes(search) ||
      property.category?.toLowerCase().includes(search) ||
      property.builder?.toLowerCase().includes(search)
    );
  });

  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: '#FDFBF7',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: '#C8873D' }} />
        <Typography variant="body1" sx={{ color: '#000000', fontWeight: 600 }}>
          Loading properties...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: '#d4caca', minHeight: '100vh' }}>
      {/* Sticky Search Bar */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 1,
          py: 1,
          backgroundColor: '#FDFBF7',
        }}
      >
        <Box sx={{ flex: 1 }}>
          <CustomSearchBar
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </Box>
      </Box>

      {/* Main Content */}
      <Box sx={{ pt: { xs: '50px', sm: '90px' }, pb: 8 }}>
        {/* Header */}
        <Box
          sx={{
            px: 2,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            mb: 1,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                color: '#1a1a1a',
                fontSize: '1.15rem',
                lineHeight: 1.2,
                position: 'relative',
                display: 'inline-block',
                pb: 0.5,
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  width: '60%',
                  height: '2px',
                  backgroundColor: '#B88A5C',
                },
              }}
            >
              Recommended Properties
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
            <East sx={{ fontSize: 16, color: '#B88A5C' }} />
            <LocationOn sx={{ fontSize: 16, color: '#B88A5C' }} />
            <Typography
              sx={{
                fontWeight: 700,
                color: '#1a1a1a',
                fontSize: '0.85rem',
                textTransform: 'capitalize',
              }}
            >
              {userCity}
            </Typography>
          </Box>
        </Box>

        {/* Category Pills */}
        <Box
          sx={{
            display: 'flex',
            gap: 1.2,
            px: 0.5,
            pb: 0.5,
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            flexWrap: 'nowrap',
            '&::-webkit-scrollbar': { display: 'none' },
            scrollbarWidth: 'none',
          }}
        >
          {categoryPills.map((cat) => {
            const isActive = activeCategory === cat;
            return (
              <Chip
                key={cat}
                label={cat}
                onClick={() => setActiveCategory(cat)}
                sx={{
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '24px',
                  width: 'fit-content',
                  minWidth: 'fit-content',
                  maxWidth: 'none',
                  flexShrink: 0,
                  height: 26,
                  backgroundColor: isActive ? '#B88A5C' : '#FFFFFF',
                  color: isActive ? '#FFFFFF' : '#4A4A4A',
                  border: isActive ? 'none' : '1px solid #D3CBC0',
                  boxShadow: isActive
                    ? '0 2px 8px rgba(184,138,92,0.35)'
                    : 'none',
                  '& .MuiChip-label': {
                    display: 'block',
                    whiteSpace: 'nowrap',
                    overflow: 'visible',
                    textOverflow: 'unset',
                    maxWidth: 'none',
                    px: 1.5,
                  },
                  '&:hover': {
                    backgroundColor: isActive ? '#A67B52' : '#F5EFE6',
                  },
                }}
              />
            );
          })}
        </Box>

        {/* Property Cards */}
        {filteredProperties.length > 0 ? (
          filteredProperties.map((property) => {
            const totalImages = property.images.length;
            const currentIndex =
              (activeImageIndex[property.id] || 0) % totalImages;

            const visibleCount = Math.min(totalImages, MAX_VISIBLE);

            const windowStart = Math.max(
              0,
              Math.min(
                currentIndex - Math.floor(visibleCount / 2),
                totalImages - visibleCount
              )
            );

            const isLiked = Boolean(cartIds[String(property.id)]);

            return (
              <Card
                key={property.id}
                onClick={() => {
                  if (hasDragged.current) return;
                  navigate(`/new-launching-properties/${property.id}`, {
                    state: {
                      propertyId: property.id,
                      property: property.propertyData,
                    },
                  });
                }}
                sx={{
                  mx: 1,
                  mb: 1,
                  borderRadius: '18px',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  backgroundColor: '#FFFFFF',
                  border: '1px solid #F0EBE4',
                  p: 1,
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': { transform: 'scale(1.01)' },
                }}
              >
                <Box
                  onTouchStart={(e) => handleDragStart(property.id, e)}
                  onTouchMove={(e) => handleDragMove(property.id, e)}
                  onTouchEnd={() => handleDragEnd(property.id, totalImages)}
                  onTouchCancel={() => handleDragEnd(property.id, totalImages)}
                  onMouseDown={(e) => handleDragStart(property.id, e)}
                  onMouseMove={(e) => handleDragMove(property.id, e)}
                  onMouseUp={() => handleDragEnd(property.id, totalImages)}
                  onMouseLeave={() => {
                    if (
                      isDragging.current &&
                      dragPropertyId.current === property.id
                    ) {
                      handleDragEnd(property.id, totalImages);
                    }
                  }}
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    height: GALLERY_HEIGHT,
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    touchAction: 'pan-y',
                    cursor: 'grab',
                  }}
                >
                  {property.images.map((img, idx) => {
                    const isMain = idx === currentIndex;
                    const inWindow =
                      idx >= windowStart && idx < windowStart + MAX_VISIBLE;
                    const isPill = inWindow && !isMain;

                    return (
                      <Box
                        key={idx}
                        onClick={
                          isPill
                            ? (e) => {
                                e.stopPropagation();
                                if (hasDragged.current) return;
                                setActiveImageIndex((prev) => ({
                                  ...prev,
                                  [property.id]: idx,
                                }));
                              }
                            : undefined
                        }
                        sx={{
                          position: 'relative',
                          height: '100%',
                          overflow: 'hidden',
                          borderRadius: isMain ? '22px' : '18px',
                          flexGrow: isMain ? 1 : 0,
                          flexShrink: isMain ? 1 : 0,
                          flexBasis: isMain
                            ? `calc(100% - ${
                                Math.max(0, visibleCount - 1) * (PILL_WIDTH + 6)
                              }px)`
                            : isPill
                              ? `${PILL_WIDTH}px`
                              : '0px',
                          minWidth: isMain ? `${MAIN_MIN_WIDTH}px` : 0,
                          maxWidth: isPill ? `${PILL_WIDTH}px` : 'none',
                          ml: inWindow && idx !== windowStart ? '6px' : 0,
                          opacity: inWindow ? 1 : 0,
                          pointerEvents: inWindow ? 'auto' : 'none',
                          cursor: isPill ? 'pointer' : 'inherit',
                          transition:
                            'flex-basis 0.5s cubic-bezier(0.4,0,0.2,1), margin 0.5s cubic-bezier(0.4,0,0.2,1), opacity 0.4s ease, border-radius 0.5s ease',
                        }}
                      >
                        <Box
                          component="img"
                          src={img || buildingImage}
                          alt={`${property.title}-${idx}`}
                          draggable={false}
                          sx={{
                            position: 'absolute',
                            inset: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center',
                            pointerEvents: 'none',
                            minWidth: '100%',
                          }}
                        />

                        {isPill && (
                          <>
                            <Box
                              sx={{
                                position: 'absolute',
                                inset: 0,
                                background:
                                  'linear-gradient(180deg, rgba(255,255,255,0) 40%, rgba(255,255,255,0.35) 100%)',
                              }}
                            />
                            <Box
                              sx={{
                                position: 'absolute',
                                bottom: 8,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                bgcolor: '#fff',
                                color: COLORS.primary,
                                fontSize: 11,
                                fontWeight: 700,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
                              }}
                            >
                              {idx + 1}
                            </Box>
                          </>
                        )}

                        {isMain && (
                          <>
                            <Box
                              sx={{
                                position: 'absolute',
                                inset: 0,
                                background:
                                  'linear-gradient(180deg, rgba(0,0,0,0) 55%, rgba(0,0,0,0.6) 100%)',
                              }}
                            />
                            <Box
                              sx={{
                                position: 'absolute',
                                left: 10,
                                bottom: 10,
                                right: 10,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 26,
                                  height: 26,
                                  flexShrink: 0,
                                  borderRadius: '50%',
                                  bgcolor: '#fff',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <LocationOn
                                  sx={{ fontSize: 16, color: COLORS.primary }}
                                />
                              </Box>
                              <Box sx={{ minWidth: 0 }}>
                                <Typography
                                  noWrap
                                  sx={{
                                    color: '#fff',
                                    fontWeight: 700,
                                    fontSize: '0.85rem',
                                    lineHeight: 1.2,
                                  }}
                                >
                                  {truncateText(property.title, 22)}
                                </Typography>
                                <Typography
                                  noWrap
                                  sx={{
                                    color: 'rgba(255,255,255,0.85)',
                                    fontSize: '0.7rem',
                                    lineHeight: 1.2,
                                  }}
                                >
                                  {property.builder}
                                </Typography>
                              </Box>
                            </Box>

                            <IconButton
                              size="small"
                              onMouseDown={(e) => e.stopPropagation()}
                              onTouchStart={(e) => e.stopPropagation()}
                              onClick={(e) => toggleLike(property.id, e)}
                              sx={{
                                position: 'absolute',
                                top: 10,
                                right: 10,
                                bgcolor: 'rgba(255,255,255,0.9)',
                                width: 32,
                                height: 32,
                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                '&:hover': { bgcolor: '#fff' },
                              }}
                            >
                              {isLiked ? (
                                <Favorite
                                  sx={{ fontSize: 17, color: '#e0432b' }}
                                />
                              ) : (
                                <FavoriteBorder
                                  sx={{ fontSize: 17, color: '#333' }}
                                />
                              )}
                            </IconButton>
                          </>
                        )}
                      </Box>
                    );
                  })}
                </Box>

                <Box sx={{ px: 1, pt: 1.5, pb: 0.5 }}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    mb={0.5}
                    gap={1}
                  >
                    <Typography
                      fontWeight={700}
                      noWrap
                      sx={{ flex: 1, fontSize: '1.05rem', color: '#222' }}
                    >
                      {truncateText(property.title, 22)}
                    </Typography>

                    <Typography
                      fontWeight={700}
                      noWrap
                      sx={{
                        fontSize: '1.05rem',
                        color: '#A97028',
                        flexShrink: 0,
                      }}
                    >
                      {property.formattedPrice}
                    </Typography>
                  </Box>

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={0.8}
                    gap={1}
                  >
                    <Typography
                      noWrap
                      sx={{
                        color: '#B88A5C',
                        fontWeight: 500,
                        flex: 1,
                        fontSize: '0.82rem',
                      }}
                    >
                      {property.builder}
                    </Typography>

                    {property.pricePerSqft && (
                      <Typography
                        noWrap
                        sx={{
                          fontSize: '0.8rem',
                          color: '#8A8A8A',
                          flexShrink: 0,
                        }}
                      >
                        {property.pricePerSqft}
                      </Typography>
                    )}
                  </Box>

                  <Box display="flex" alignItems="center" mb={1} gap={0.5}>
                    <LocationOn sx={{ fontSize: 16, color: '#8A8A8A' }} />
                    <Typography
                      noWrap
                      sx={{ flex: 1, fontSize: '0.82rem', color: '#8A8A8A' }}
                    >
                      {property.address}
                    </Typography>
                  </Box>

                  <Box sx={{ borderTop: '1px solid #EAEAEA', mb: 1.2 }} />

                  {property.bhkConfigs &&
                    property.bhkConfigs.length > 0 &&
                    (() => {
                      const uniqueMap = new Map();

                      property.bhkConfigs.forEach((cfg) => {
                        const key = cfg.bhk_type;
                        const price = Number(cfg.price);

                        if (!uniqueMap.has(key)) {
                          uniqueMap.set(key, { ...cfg });
                        } else {
                          const existing = uniqueMap.get(key);
                          const existingPrice = Number(existing.price);

                          if (
                            !Number.isNaN(price) &&
                            price > 0 &&
                            (Number.isNaN(existingPrice) ||
                              existingPrice <= 0 ||
                              price < existingPrice)
                          ) {
                            uniqueMap.set(key, { ...cfg });
                          }
                        }
                      });

                      const uniqueConfigs = Array.from(uniqueMap.values()).sort(
                        (a, b) => BHK_SORT(a.bhk_type, b.bhk_type)
                      );

                      return (
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 0.8,
                            mb: 1.2,
                          }}
                        >
                          {uniqueConfigs.map((cfg, idx) => (
                            <Paper
                              key={cfg.id ?? `${cfg.bhk_type}-${idx}`}
                              elevation={0}
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(
                                  `/new-launching-properties/${property.id}`,
                                  {
                                    state: {
                                      propertyId: property.id,
                                      property: property.propertyData,
                                    },
                                  }
                                );
                              }}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                px: 1.2,
                                py: 0.8,
                                borderRadius: 2,
                                cursor: 'pointer',
                                border: `1px solid ${COLORS.border}`,
                                boxShadow: 'none',
                                bgcolor: 'white',
                                transition: 'background 0.15s ease',
                                '&:hover': { bgcolor: '#FAFAFA' },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: 700,
                                  color: COLORS.textDark,
                                }}
                              >
                                {getTypeLabel(cfg.bhk_type, property.propertyType)}
                              </Typography>

                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 0.6,
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: '12.5px',
                                    fontWeight: 600,
                                    color: COLORS.primary,
                                  }}
                                >
                                  {cfg.price !== undefined && cfg.price !== null
                                    ? `Starting at ${formatPrice(cfg.price)}`
                                    : 'Price on Request'}
                                </Typography>
                                <ChevronRight
                                  sx={{
                                    color: COLORS.textSecondary,
                                    fontSize: 18,
                                  }}
                                />
                              </Box>
                            </Paper>
                          ))}
                        </Box>
                      );
                    })()}

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    gap={1}
                  >
                    <Typography
                      noWrap
                      sx={{
                        fontSize: '0.8rem',
                        color: '#A97028',
                        fontWeight: 600,
                        flex: 1,
                      }}
                    >
                      {property.propertyType}
                    </Typography>

                    <Typography
                      noWrap
                      sx={{ fontSize: '0.8rem', color: '#555', flexShrink: 0 }}
                    >
                      Possession:{' '}
                      <Box
                        component="span"
                        sx={{ color: '#A97028', fontWeight: 600 }}
                      >
                        {formatPossessionDate(property.possession)}
                      </Box>
                    </Typography>
                  </Box>
                </Box>
              </Card>
            );
          })
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 200,
              px: 2,
            }}
          >
            <Typography>No properties found matching your search.</Typography>
          </Box>
        )}
      </Box>

      {/* --- ADDED SUCCESS MODAL DIRECTLY HERE --- */}
      <AlertModal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title="Added to Wishlist"
        message="This property has been added to your Wishlist."
        isSuccess={true} 
      />
    </Box>
  );
};

export default NewList;